var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoMessagingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#FD6003"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 37C18.4696 37 17.9609 36.7893 17.5858 36.4142C17.2107 36.0391 17 35.5304 17 35V25C17 24.4696 17.2107 23.9609 17.5858 23.5858C17.9609 23.2107 18.4696 23 19 23H32C32.5304 23 33.0391 23.2107 33.4142 23.5858C33.7893 23.9609 34 24.4696 34 25V35C34 35.5304 33.7893 36.0391 33.4142 36.4142C33.0391 36.7893 32.5304 37 32 37H19ZM36 33L40.445 35.964C40.5957 36.0645 40.7708 36.1222 40.9517 36.131C41.1326 36.1397 41.3125 36.0992 41.4722 36.0136C41.6319 35.9281 41.7653 35.8008 41.8583 35.6454C41.9512 35.4899 42.0002 35.3121 42 35.131V24.869C42 24.688 41.9509 24.5103 41.8579 24.355C41.7648 24.1997 41.6314 24.0725 41.4718 23.9871C41.3121 23.9017 41.1323 23.8612 40.9515 23.87C40.7707 23.8788 40.5956 23.9365 40.445 24.037L36 27V33Z",
    fill: "#FD6003"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoMessagingIcon);
export default __webpack_public_path__ + "static/media/video-messaging-icon.b785cef76e7b7058b02d6d9979496c00.svg";
export { ForwardRef as ReactComponent };